import { render, staticRenderFns } from "./number-grow.vue?vue&type=template&id=2dcb5dd8&scoped=true&"
import script from "./number-grow.vue?vue&type=script&lang=js&"
export * from "./number-grow.vue?vue&type=script&lang=js&"
import style0 from "./number-grow.vue?vue&type=style&index=0&id=2dcb5dd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcb5dd8",
  null
  
)

export default component.exports